import { DashboardFilter } from '../interfaces/dashboard.interface';

export class SaveDashboardFilter {
    static readonly type = '[Dashboard Filter] Save dashboard filters';
    constructor(public dashboardFilter: DashboardFilter) { }
}
